//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import { CommonServices } from "@/services/CommonServices";
import { baseUrl } from '@/config';
class _CentroDiCostoClient {
    getAll(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/CentroDiCosto/GetAll', {}, showSpinner);
    }
    save(item, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/CentroDiCosto/Save', item, {}, showSpinner);
    }
    deleteById(identifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/CentroDiCosto/DeleteById', { identifier }, showSpinner);
    }
}
export let CentroDiCostoClient = new _CentroDiCostoClient();
class _JdeImportErrorClient {
    getAll(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/JdeImportError/GetAll', {}, showSpinner);
    }
    dismiss(identifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/JdeImportError/Dismiss', { identifier }, showSpinner);
    }
}
export let JdeImportErrorClient = new _JdeImportErrorClient();
class _LoginClient {
    loginWithPassword(password, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Login/LoginWithPassword', { password }, showSpinner);
    }
    login(username, password, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Login/Login', { username, password }, showSpinner);
    }
    loginFromOnOfficeMarketplace(userId, customerWebId, apiClaim, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Login/LoginFromOnOfficeMarketplace', { userId, customerWebId, apiClaim }, showSpinner);
    }
    checkLoggedIn(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Login/CheckLoggedIn', {}, showSpinner);
    }
    checkAdmin(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Login/CheckAdmin', {}, showSpinner);
    }
    checkApprover(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Login/CheckApprover', {}, showSpinner);
    }
}
export let LoginClient = new _LoginClient();
class _LoginUserClient {
    getAll(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/LoginUser/GetAll', {}, showSpinner);
    }
    getByConnectedUser(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/LoginUser/GetByConnectedUser', {}, showSpinner);
    }
    save(item, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/LoginUser/Save', item, {}, showSpinner);
    }
    create(item, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/LoginUser/Create', item, {}, showSpinner);
    }
    updatePassword(identifier, newPassword, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/LoginUser/UpdatePassword', { identifier, newPassword }, showSpinner);
    }
    deleteById(identifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/LoginUser/DeleteById', { identifier }, showSpinner);
    }
}
export let LoginUserClient = new _LoginUserClient();
class _MarketplaceClient {
    checkSignature(message, signature, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Marketplace/CheckSignature', { message, signature }, showSpinner);
    }
    getSignature(message, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Marketplace/GetSignature', { message }, showSpinner);
    }
    activateMarketplace(userSecretKey, apiToken, apiClaim, parameterCacheId, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Marketplace/ActivateMarketplace', { userSecretKey, apiToken, apiClaim, parameterCacheId }, showSpinner);
    }
}
export let MarketplaceClient = new _MarketplaceClient();
class _MonitoraggioClient {
    getTotaleMovimenti(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Monitoraggio/GetTotaleMovimenti', vm, {}, showSpinner);
    }
    getForecastData(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Monitoraggio/GetForecastData', vm, {}, showSpinner);
    }
    getBusinessUnits(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Monitoraggio/GetBusinessUnits', {}, showSpinner);
    }
    getSedi(businessUnit, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Monitoraggio/GetSedi', { businessUnit }, showSpinner);
    }
    downloadLastForecast(businessUnit, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Monitoraggio/DownloadLastForecast', { businessUnit }, showSpinner);
    }
}
export let MonitoraggioClient = new _MonitoraggioClient();
class _MovimentoClient {
    getRicaviByProposta(propostaIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Movimento/GetRicaviByProposta', { propostaIdentifier }, showSpinner);
    }
    getIncassiByProposta(propostaIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Movimento/GetIncassiByProposta', { propostaIdentifier }, showSpinner);
    }
    deleteById(identifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Movimento/DeleteById', { identifier }, showSpinner);
    }
}
export let MovimentoClient = new _MovimentoClient();
class _OnOfficeUserClient {
    getPagedAnagraficaUtente(page, count, nome, cognome, username, email, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/OnOfficeUser/GetPagedAnagraficaUtente', { page, count, nome, cognome, username, email }, showSpinner);
    }
    getGroups(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/OnOfficeUser/GetGroups', {}, showSpinner);
    }
}
export let OnOfficeUserClient = new _OnOfficeUserClient();
class _PermessiInvioClient {
    getAll(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/PermessiInvio/GetAll', {}, showSpinner);
    }
    getByConnectedUser(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/PermessiInvio/GetByConnectedUser', {}, showSpinner);
    }
    save(item, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/PermessiInvio/Save', item, {}, showSpinner);
    }
    deleteById(identifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/PermessiInvio/DeleteById', { identifier }, showSpinner);
    }
}
export let PermessiInvioClient = new _PermessiInvioClient();
class _PropostaClient {
    deleteById(identifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Proposta/DeleteById', { identifier }, showSpinner);
    }
    getAllAll(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Proposta/GetAll', {}, showSpinner);
    }
    getAll(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Proposta/GetAll', vm, {}, showSpinner);
    }
    getAllForApprovazione(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Proposta/GetAllForApprovazione', vm, {}, showSpinner);
    }
    getByBusinessUnit(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Proposta/GetByBusinessUnit', vm, {}, showSpinner);
    }
    getByEstateId(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Proposta/GetByEstateId', vm, {}, showSpinner);
    }
    getById(identifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Proposta/GetById', { identifier }, showSpinner);
    }
    generateNewPropostaByNumeroImmobile(numeroImmobile, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Proposta/GenerateNewPropostaByNumeroImmobile', { numeroImmobile }, showSpinner);
    }
    getImmobileByEstateId(estateId, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Proposta/GetImmobileByEstateId', { estateId }, showSpinner);
    }
    getEstateDetailsByNumeroImmobile(numeroImmobile, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Proposta/GetEstateDetailsByNumeroImmobile', { numeroImmobile }, showSpinner);
    }
    getBuyersInProposta(propostaIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Proposta/GetBuyersInProposta', { propostaIdentifier }, showSpinner);
    }
    getOwnersInProposta(propostaIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Proposta/GetOwnersInProposta', { propostaIdentifier }, showSpinner);
    }
    getCustomersInProposta(propostaIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Proposta/GetCustomersInProposta', { propostaIdentifier }, showSpinner);
    }
    getPagedEstates(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Proposta/GetPagedEstates', vm, {}, showSpinner);
    }
    getPagedAnagraficaUtente(page, count, nome, cognome, codiceFiscale, ragioneSociale, partitaIva, matricola, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Proposta/GetPagedAnagraficaUtente', { page, count, nome, cognome, codiceFiscale, ragioneSociale, partitaIva, matricola }, showSpinner);
    }
    syncPropostaDetails(propostaIdentifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Proposta/SyncPropostaDetails', { propostaIdentifier }, showSpinner);
    }
    getAnagraficaUtenteByUserId(userId, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Proposta/GetAnagraficaUtenteByUserId', { userId }, showSpinner);
    }
    getAnagraficaUtenteByAddressId(addressId, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Proposta/GetAnagraficaUtenteByAddressId', { addressId }, showSpinner);
    }
    save(item, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Proposta/Save', item, {}, showSpinner);
    }
    exportForecast(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Proposta/ExportForecast', vm, {}, showSpinner);
    }
    exportAll(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Proposta/ExportAll', {}, showSpinner);
    }
    exportCsv(vm, showSpinner = true) {
        return CommonServices.defaultPost(baseUrl + 'api/Proposta/ExportCsv', vm, {}, showSpinner);
    }
    getAllWaitingApproval(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Proposta/GetAllWaitingApproval', {}, showSpinner);
    }
    checkAndSetToApprove(identifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Proposta/CheckAndSetToApprove', { identifier }, showSpinner);
    }
    approveAndSetSendable(identifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Proposta/ApproveAndSetSendable', { identifier }, showSpinner);
    }
    resetSendability(identifier, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Proposta/ResetSendability', { identifier }, showSpinner);
    }
    setPropostaNonInviata(identifier, notaPropostaNonInviata, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Proposta/SetPropostaNonInviata', { identifier, notaPropostaNonInviata }, showSpinner);
    }
    setPropostaNonApprovata(identifier, notaPropostaNonApprovata, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Proposta/SetPropostaNonApprovata', { identifier, notaPropostaNonApprovata }, showSpinner);
    }
    exportAnagraficaContrattiCsv(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Proposta/ExportAnagraficaContrattiCsv', {}, showSpinner);
    }
    exportAnagraficaImmobiliCsv(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Proposta/ExportAnagraficaImmobiliCsv', {}, showSpinner);
    }
    exportAnagraficaUtentiCsv(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Proposta/ExportAnagraficaUtentiCsv', {}, showSpinner);
    }
    exportFunzionariSegnalatoriCsv(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Proposta/ExportFunzionariSegnalatoriCsv', {}, showSpinner);
    }
}
export let PropostaClient = new _PropostaClient();
class _ScheduledClient {
    testFtpConnection(psw, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Scheduled/TestFtpConnection', { psw }, showSpinner);
    }
    sendFtpFile(psw, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Scheduled/SendFtpFile', { psw }, showSpinner);
    }
    readFtpFile(psw, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Scheduled/ReadFtpFile', { psw }, showSpinner);
    }
    testSendFtpFile(psw, showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Scheduled/TestSendFtpFile', { psw }, showSpinner);
    }
}
export let ScheduledClient = new _ScheduledClient();
class _TranslationsClient {
    getTranslationsOptions(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Translations/GetTranslationsOptions', {}, showSpinner);
    }
    getAssetClassOptions(showSpinner = true) {
        return CommonServices.defaultGet(baseUrl + 'api/Translations/GetAssetClassOptions', {}, showSpinner);
    }
}
export let TranslationsClient = new _TranslationsClient();
class SwaggerException extends Error {
    message;
    status;
    response;
    headers;
    result;
    constructor(message, status, response, headers, result) {
        super();
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    isSwaggerException = true;
    static isSwaggerException(obj) {
        return obj.isSwaggerException === true;
    }
}
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}
